import axios from 'axios'

const service = axios.create({
    // baseURL: process.env.VUE_APP_BASE_API,
    baseURL: process.env.VUE_APP_PROD_API,
    timeout: 15000
})

// 请求拦截器：自动带上 token（如有）
service.interceptors.request.use(
    config => {
        // 若请求已显式设置 user-token（如上传接口传空），则不覆盖
        if (!('user-token' in config.headers)) {
            const token = localStorage.getItem('token') || ''
            config.headers['user-token'] = token
        }
        return config
    },
    error => Promise.reject(error)
)

// 响应拦截器：统一处理业务 code
service.interceptors.response.use(
    response => {
        const res = response.data
        // 若后端用 { code, data, msg } 结构，可在此判断 code
        return res
    },
    error => {
        return Promise.reject(error)
    }
)

export default service
